// extracted by mini-css-extract-plugin
export var arrows = "_59-5";
export var decrementer = "_59-9";
export var disabled = "_59-3";
export var error = "_59-1";
export var hiddenText = "_59-a";
export var incrementer = "_59-8";
export var input = "_59-7";
export var inputWrapper = "_59-0";
export var readonly = "_59-2";
export var regular = "_59-6";
export var small = "_59-4";